import { Injectable, signal } from "@angular/core";

export const DEV_SECTIONS = ["page", "settings", "actions", "goto", "diagnostics"] as const;
export type DevSectionId = (typeof DEV_SECTIONS)[number];

/**
 * Holds which dev panel section is active. Provided by `DevPanelModalComponent`,
 * not `providedIn: "root"`.
 */
@Injectable()
export class DevPanelShell {
  private readonly requested = signal<DevSectionId>("page");
  readonly active = this.requested.asReadonly();

  select(id: DevSectionId): void {
    this.requested.set(id);
  }
}
